export * from './spinner-loader.component'



// WEBPACK FOOTER //
// ./src/app/shared/components/spinner-loader/index.ts